import { render, staticRenderFns } from "./customizer.vue?vue&type=template&id=1d233105&scoped=true&"
import script from "./customizer.vue?vue&type=script&lang=js&"
export * from "./customizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d233105",
  null
  
)

export default component.exports